var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_5841)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 0C25.9797 2.57702e-07 28.666 2.68629 28.666 6V22C28.666 25.3137 25.9797 28 22.666 28H6.66602C3.35231 28 0.666016 25.3137 0.666016 22V6C0.666016 2.68629 3.35231 3.22128e-08 6.66602 0H22.666ZM6.0957 8.27832V20.8896L6.26758 21.0615H10.2227C10.4794 22.0532 10.221 23.108 10.3311 24.1055C10.3505 24.2786 10.3425 24.3901 10.5088 24.499L13.8936 21.1211L16.9365 20.9541L23.1797 14.6992V4.83887L23.0078 4.66699H9.70703L6.0957 8.27832ZM21.6904 6.3291V13.8975L18.9365 16.6475L16.0381 16.7295C15.7125 16.8258 14.3476 18.4807 13.8936 18.8281C13.7779 18.9163 13.749 19.0492 13.5488 18.999V16.7061H10.4531V6.15723H21.5186L21.6904 6.3291ZM18.1348 12.8076H19.5107V8.67969H18.1348V12.8076ZM14.2363 12.8066H15.7266C15.7701 12.6828 15.6123 12.5561 15.6123 12.5205V8.67969H14.2363V12.8066Z",
    fill: "#A441F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1114_5841",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 18,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1796 4.6665H6.0957V24.4998H23.1796V4.6665Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1114_5841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1796 14.6989L16.9365 20.9535L13.8935 21.1209L10.5088 24.4987C10.3426 24.3897 10.3506 24.2785 10.3311 24.1054C10.2211 23.1079 10.479 22.053 10.2222 21.0612H6.26769L6.0957 20.8893V8.27819L9.70739 4.6665H23.0076L23.1796 4.83849V14.6989ZM13.5484 18.9986C13.749 19.049 13.7777 18.916 13.8935 18.8277C14.3476 18.4803 15.712 16.8258 16.0376 16.7295L18.9361 16.647L21.6902 13.8975V6.32903L21.5182 6.15704H10.4527V16.7054H13.5484V18.9986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9366 16.6472L16.0381 16.7297L13.8545 18.8624C13.7684 18.9463 13.7247 19.043 13.5489 18.9988V16.7056H10.4531V6.15723H21.5187L21.6906 6.32922V13.9635L18.9366 16.6472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6122 8.67969V12.5207C15.6122 12.5562 15.7704 12.6823 15.7269 12.8062H14.2363V8.67969H15.6122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5106 8.67969H18.1348V12.8073H19.5106V8.67969Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_5841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatImage);
export default __webpack_public_path__ + "static/media/chat-image.c2aad4ef633cb95f381a479023e86da3.svg";
export { ForwardRef as ReactComponent };